export default __webpack_public_path__ + "static/media/analytics.fa776761.png";